<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
            <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
              <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>NFO</span>
            </a>
          </li> -->

          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div>
        <div *ngIf="!IsMobile" class="SectionHeading">Scheme Returns</div>
        <div
          *ngIf="IsMobile"
          class="CommonSelectBoxTabsOuter CommonSelectBoxForm">
          <div class="SectionTopHeading HeadingReport NewHeaders fixed-top p-0">
            <span class="Mob_Heading_Top">Resources</span>
          </div>
          <div
            class="ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs">
            <ul class="nav nav-tabs p-0 Reports_Mob">
              <li>
                <a
                  routerLink="/value-add-service/branding"
                  routerLinkActive="active">
                  Branding Images
                </a>
              </li>
              <li>
                <a
                  class="active show"
                  routerLink="/value-add-service/scheme-returns"
                  routerLinkActive="active">
                  Scheme Returns
                </a>
              </li>
              <li class="d-none">
                <a
                  routerLink="/value-add-service/schemeperformancelumpsum"
                  routerLinkActive="active">
                  Lumpsum Performance
                </a>
              </li>
              <!-- <li>
                        <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>NFO</a>
                      </li> -->
            </ul>
          </div>
        </div>
        <form
          autocomplete="off"
          [formGroup]="Transactionform"
          class="FormOuter_Mob">
          <div class="MinLeftFormHeightTransact">
            <!-- <div class="row">
                        <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                            <div class="has-float-label">
                            <input type="text" id="FromDate" formControlName="FromDate"
                                [ngClass]="{ 'is-invalid': TransactionSubmitted && l.FromDate.errors }"
                                class="form-control CommonTextBox TbxMarginBtm clsDatePickerFromDate clsCommonDatePicker"
                                  placeholder="&nbsp;" />
                            <label for="FromDate">From Date</label>
                            <div *ngIf="TransactionSubmitted && l.FromDate.errors" class="invalid-feedback">
                                <div *ngIf="l.FromDate.errors.required">Please Select From Date</div>
                                <div *ngIf="l.FromDate.errors.pattern">Please Enter Valid Date</div>
                            </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                            <div class="has-float-label">
                            <input type="text" formControlName="ToDate" id="ToDate"
                                [ngClass]="{ 'is-invalid': TransactionSubmitted && l.ToDate.errors }"
                                class="form-control CommonTextBox TbxMarginBtm clsDatePickerToDate clsCommonDatePicker" placeholder="&nbsp;" />
                                <label for="ToDate">To Date</label>
                            <div *ngIf="TransactionSubmitted && l.ToDate.errors" class="invalid-feedback">
                                <div *ngIf="l.ToDate.errors.required">Please Select To Date</div>
                                <div *ngIf="l.ToDate.errors.pattern">Please Enter Valid Date</div>
                            </div>
                            </div>

                        </div>
                    </div>-->
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <!-- <select formControlName="AMC" class="form-control CommonSelectBox TbxMarginBtm "
                            [ngClass]="{ 'is-invalid': TransactionSubmitted && l.AMC.errors }">
                                <option value="" disabled='true' selected>Select AMC</option>
                                <option *ngFor="let AMC of SelectedAMC" [value]="AMC.VALUEFIELD">{{AMC.TEXTFIELD}}</option>
                            </select> -->
                  <ng-multiselect-dropdown-angular7
                    [ngModelOptions]="{ standalone: true }"
                    [placeholder]="'Select AMC '"
                    [data]="SelectedAMC"
                    [(ngModel)]="selectedItemsAMC"
                    [settings]="dropdownSettings"
                    (onSelect)="onItemSelect($event)"
                    (onDeSelect)="onItemSelect($event)"
                    (onSelectAll)="onItemSelectDeselectAll($event, 0)"
                    (onDeSelectAll)="
                      onItemSelectDeselectAll($event, 1)
                    "></ng-multiselect-dropdown-angular7>
                  <label>AMC</label>
                  <!-- <div *ngIf="TransactionSubmitted && l.AMC.errors" class="invalid-feedback">
                                <div *ngIf="l.AMC.errors.required">Please Select AMC</div>
                            </div> -->
                </div>
              </div>

              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="Asset_type"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect6">
                    <option value="" disabled="true">Asset Type</option>
                    <option value="1" Selected>Equity</option>
                    <option value="2">Debt</option>
                    <option value="3">Hybrid</option>
                    <option value="4">Commodity</option>
                  </select>
                  <label>Asset Class</label>
                  <!-- <div *ngIf="TransactionSubmitted && l.Asset_type.errors" class="invalid-feedback">
                            <div *ngIf="l.Asset_type.errors.required">Please Select Asset Class</div>
                        </div> -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="SubAsset_type"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect3"
                    [ngClass]="{
                      'is-invalid':
                        TransactionSubmitted && l.SubAsset_type.errors
                    }">
                    <option value="" disabled="true">
                      Select Sub Asset Type
                    </option>
                    <option
                      *ngFor="let nature of SelectedSubAsset"
                      [value]="nature.VALUEFIELD">
                      {{ nature.TEXTFIELD }}
                    </option>
                  </select>
                  <label>Sub Asset Class</label>
                  <div
                    *ngIf="TransactionSubmitted && l.SubAsset_type.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.SubAsset_type.errors.required">
                      Please Select Sub Asset Class
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="SchemeOption"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect5"
                    [ngClass]="{
                      'is-invalid':
                        TransactionSubmitted && l.SchemeOption.errors
                    }">
                    <!-- <option value="" disabled='true'>Scheme Option</option>                                     -->
                    <option value="Growth">Growth</option>
                    <option value="Dividend">IDCW</option>
                  </select>
                  <label>Scheme Option</label>
                  <div
                    *ngIf="TransactionSubmitted && l.SchemeOption.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.SchemeOption.errors.required">
                      Please Select Scheme Option
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">


                    </div> -->
          </div>

          <div class="SubmitMarginTop">
            <button
              class="CommonSubmitButton"
              [disabled]="Transactionform.value == '' || !Transactionform.valid"
              (click)="onSubmitTransaction()">
              Show Report
            </button>
          </div>
          <!-- <div class="SubmitMarginTop">
                      <button class="CommonSubmitButton" [disabled]="" (click)="ExportTOExcelALL()">Export To Excel</button>
                  </div> -->
          <!--<h6>{{Transactionform.value | json}}</h6> -->
        </form>
      </div>
    </div>
  </div>
  <div id="TblReportSection">
    <div
      [ngClass]="IsShowReport ? 'd-block' : 'd-none'"
      class="MainInnerFormWithoutFlex mt-0">
      <div *ngIf="!IsMobile" class="SectionTopHeading w-100">
        <span class="ReportHead"><b>Scheme Return Report</b></span>
        <div class="RightSideTabs">
          <ul class="nav nav-tabs p-0">
            <!-- <button *ngIf="!IsCallCenterTeam" class=" ml-2" (click)='ExportToPdf()'>
                                    <img
                                    src="../../../assets/images/PDF_Export.svg"
                                    class="ExportToIcon"
                                    type="image/svg+xml"
                                    fill="#fff"
                                    width="12px"
                                    pluginspage="http://www.adobe.com/svg/viewer/install/"/></button> -->
            <button class="ml-2" (click)="ExportTOExcelALL()">
              <img
                src="../../assets/images/IFA/Excel_Export.svg"
                class="ExportToIcon"
                type="image/svg+xml"
                fill="#fff"
                width="12px"
                style="width: 27px !important; height: 29px !important"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
            </button>
          </ul>
        </div>
      </div>
      <div
        *ngIf="IsMobile"
        class="SectionTopHeading HeadingReport NewHeaders fixed-top d-flex p-0">
        <span (click)="ShowFilters()">
          <img
            src="../../../assets/images/IFA/BackArrow-Updated.svg"
            class="BackIcon" />
        </span>
        <span class="Mob_Heading w-100 justify-content-center">
          Scheme Returns
        </span>
        <!-- <span class="ml-auto" (click)='ExportTOExcelALL()'>
                    <img src="../../../assets/images/IFA/Excel_Export.svg" class="ExportToIcon" type="image/svg+xml"
                            fill="#fff" width="12px" pluginspage="http://www.adobe.com/svg/viewer/install/" />
                    </span> -->
      </div>
      <div class="">
        <div *ngIf="!IsMobile" class="tab-content pt-0">
          <div id="SchemeReport" class="tab-pane fade show active">
            <table id="ReportTable" class="CommonTable ClsReportTable w-100">
              <thead>
                <tr>
                  <th>Scheme Name</th>
                  <th class="no-sort">Sub Asset Class</th>
                  <!--<th class="no-sort d-none">Scheme Type</th> -->
                  <th class="no-sort">Fund Manager</th>
                  <th>Launch Date</th>
                  <th class="">AUM (Cr)</th>
                  <th class="no-sort text-right">NAV</th>
                  <th class="no-sort text-right">1W(%)</th>
                  <th class="no-sort text-right">1M(%)</th>
                  <th class="no-sort text-right">3M(%)</th>
                  <th class="no-sort text-right">6M(%)</th>
                  <th class="text-right">1Y(%)</th>
                  <th class="no-sort text-right">2Y(%)</th>
                  <th class="text-right">3Y(%)</th>
                  <th class="no-sort text-right">4Y(%)</th>
                  <th class="text-right">5Y(%)</th>
                  <!-- <th class="text-right d-none">Inception</th> -->
                </tr>
              </thead>
              <!-- <tbody>
                                    <tr *ngFor="let c of ReportData">
                                        <td>{{c.SchemeName}}</td>
                                        <td>{{c.Sub_Asset_Class}}</td>
                                        <td>{{c.Scheme_Type}}</td>
                                        <td>{{c.FundManager}}</td>
                                        <td>{{c.Launchdate | date: 'dd/MM/yyyy'}}</td>
                                        <td>{{c.AUM}}</td>
                                        <td>{{c.Nav.toLocaleString('en-IN', { minimumFractionDigits: 4
                                        }).replaceAll(',', '')}}</td>
                                        <td>{{c.Returns_1W}}</td>
                                        <td>{{c.Returns_1M}}</td>
                                        <td>{{c.Returns_3M}}</td>
                                        <td>{{c.Returns_6M}}</td>
                                        <td>{{c.Returns_1Y}}</td>
                                        <td>{{c.Returns_2Y}}</td>
                                        <td>{{c.Returns_3Y}}</td>
                                        <td>{{c.Returns_4Y}}</td>
                                        <td>{{c.Returns_5Y}}</td>
                                        <td>{{c.Returns_Inception}}</td>
                                    </tr>
                                </tbody> -->
            </table>
          </div>
        </div>
        <div *ngIf="IsMobile" class="pt-0 MainBg Mb60px">
          <div *ngFor="let c of ReportData" class="TopMost-Inner BorderBottom ">
            <div class="SummaryCard Brdr">
              <div class="TopMost-0">{{ c.SchemeName }}</div>
              <div class="TopMost-1">
                <span class="SubText_Mob">
                  <span class="Re">Fund Manager </span>
                  &nbsp;{{ c.FundManager }}
                </span>
              </div>
            </div>
            <div class="TopMost-2">
              <div class="PlaceSlefStart">
                <div class="d-flex justify-content-start"><label>AUM (Cr)</label></div>
                <span class="GrayClr d-flex justify-content-start FontFamilyMedium">{{ c.AUM }}</span>
              </div>
              <div class="PlaceSlefCenter">
                <div class="d-flex justify-content-center"><label>NAV</label></div>
                <span class="GrayClr d-flex justify-content-center FontFamilyMedium">
                  {{
                    c.Nav.toLocaleString('en-IN', {
                      minimumFractionDigits: 4
                    }).replaceAll(',', '')
                  }}
                </span>
              </div>
              <div class="PlaceSlefEnd">
                <div class="d-flex justify-content-end"><label>Launch Date</label></div>
                <span class="GrayClr d-flex justify-content-end FontFamilyMedium">{{ c.Launchdate }}</span>
              </div>
              <div class="PlaceSlefStart">
                <div class="d-flex justify-content-start"><label>1Y Returns</label></div>
                <span class="GrayClr d-flex justify-content-start FontFamilyMedium">{{ c.Returns_1Y }}%</span>
              </div>
              <div class="PlaceSlefCenter">
                <div class="d-flex justify-content-center"><label>3Y Returns</label></div>
                <span class="GrayClr d-flex justify-content-center FontFamilyMedium">{{ c.Returns_3Y }}%</span>
              </div>
              <div class="PlaceSlefEnd">
                <div class="d-flex justify-content-end"><label>5Y Returns</label></div>
                <span class="GrayClr d-flex justify-content-end FontFamilyMedium">{{ c.Returns_5Y }}%</span>
              </div>
            </div>
            <!-- <div class="InceptionCard">
                            <span class="Re">Inception Returns :
                              <span class="ReValue" [ngClass]="c.Returns_Inception < 0 ? 'ColorRed' : 'ColorGreen'">
                                {{c.Returns_Inception}}%
                              </span>
                            </span>
                          </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div *ngIf='!IsMobile' class="tab-content pt-0 ">
            <div id="SchemeReport" class="tab-pane fade show active">
                <table id="ReportTable" class="CommonTable ClsReportTable">
                    <thead>
                        <tr>
                            <th>AMC Name</th>
                            <th>Scheme Name</th>
                            <th>Sub Asset Class</th>
                            <th>Scheme Type</th>
                            <th>Scheme Option</th>
                            <th> Fund Manager</th>
                            <th>Launch Date</th>
                            <th>AUM</th>
                            <th>NAV</th>
                            <th>1W(%)</th>
                            <th>1M(%)</th>
                            <th>3M(%)</th>
                            <th>6M(%)</th>
                            <th>1Y(%)</th>
                            <th>2Y(%)</th>
                            <th>3Y(%)</th>
                            <th>4Y(%)</th>
                            <th>5Y(%)</th>
                            <th>Inception</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let c of ReportData">
                            <td>{{c.AMC_Name}}</td>
                            <td>{{c.SchemeName}}</td>
                            <td>{{c.Sub_Asset_Class}}</td>
                            <td>{{c.Scheme_Type}}</td>
                            <td>{{c.Scheme_Option}}</td>
                            <td>{{c.FundManager}}</td>
                            <td>{{c.Launchdate| date: 'dd/MM/yyyy'}}</td>
                            <td>{{c.AUM}}</td>
                            <td>{{c.Nav}}</td>
                            <td>{{c.Returns_1W}}</td>
                            <td>{{c.Returns_1M}}</td>
                            <td>{{c.Returns_3M}}</td>
                            <td>{{c.Returns_6M}}</td>
                            <td>{{c.Returns_1Y}}</td>
                            <td>{{c.Returns_2Y}}</td>
                            <td>{{c.Returns_3Y}}</td>
                            <td>{{c.Returns_4Y}}</td>
                            <td>{{c.Returns_5Y}}</td>
                            <td>{{c.Returns_Inception}}</td>
                        </tr>
                    </tbody>

                </table>
            </div>


        </div>  -->
  </div>
</div>
<span *ngIf="!IsMobile">
  <app-footer></app-footer>
</span>
